/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidAuditTab200,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidAuditTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidAuditTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidAuditTab500,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidAuditTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidAuditTabQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidAuditTab.ts";
import { courseRegistrationManagementAuditViewModelSchema } from "../courseRegistrationManagementAuditViewModelSchema.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidAuditTabPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidAuditTabPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidAuditTab200Schema =
  z.lazy(
    () => courseRegistrationManagementAuditViewModelSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidAuditTab200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidAuditTab400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidAuditTab400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidAuditTab401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidAuditTab401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidAuditTab500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidAuditTab500>;

export const getApiV1CourseregistrationEnrollmentCourseregistrationidAuditTabQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationEnrollmentCourseregistrationidAuditTab200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidAuditTabQueryResponse>;
